import { createContext } from 'react';
import PropTypes from 'prop-types';

const HookFormContext = createContext();

const HookFormProvider = ({
  control,
  trigger,
  watch,
  setValue,
  errors,
  setError,
  clearErrors,
  reset,
  handleBlur,
  options,
  children,
}) => (
  <HookFormContext.Provider
    value={{
      control,
      trigger,
      watch,
      setValue,
      errors,
      setError,
      clearErrors,
      reset,
      handleBlur,
      ...options,
    }}>
    {children}
  </HookFormContext.Provider>
);

HookFormProvider.propTypes = {
  control: PropTypes.object.isRequired,
  trigger: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  setValue: PropTypes.func,
  errors: PropTypes.object.isRequired,
  setError: PropTypes.func,
  clearErrors: PropTypes.func,
  reset: PropTypes.func,
  handleBlur: PropTypes.func,
  options: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export { HookFormContext, HookFormProvider };
